export default __webpack_public_path__ + "static/media/totalBonus.713f834a.svg";